import '../../../assets/css/bills.css'
import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import '../../../components/purchase_service/applicant_requests/applicant_requests.css'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import { add_quote_to_orderRequest } from '../../../services/purchase_service';
import { download_orderRequest_quote } from '../../../services/for_allServices';
import { get_off_catalogue_supplier_requests, notify_purchase_service_with_quote_upload } from '../../../services/supplier_service';

import View_refuse_reason from './view_refuse_reason/view_refuse_reason';
const useStyles = makeStyles({
    input: {
        display: 'none',
    },
});


function Supplier_quotes() {
    const classes = useStyles();
    const [quotePath, setQuotePath] = useState(null);
    const [open_reason_modal, setOpen_reason_modal] = useState(null);
    const [requests, setRequests] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [wait_submitting, setwait_submitting] = useState(false);

    let supplier = JSON.parse(localStorage.getItem('user-info'))



    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const initialPage = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1;
        load_data(initialPage);
    }, [quotePath]);


    const load_data = async (page = 1) => {
        setwait_submitting(true);
        let formData = new FormData();
        formData.append('id_supplier', supplier.id);
        //formData.append('page', page);

        try {
            const response = await get_off_catalogue_supplier_requests(formData, page);
            setRequests(response.data.data);
            setTotalItems(response.data.total);
            setCurrentPage(response.data.current_page);
            setQuotePath(response.data.quote); // optional: store for later use
        } catch (error) {
            console.log(error.response);
        } finally {
            setwait_submitting(false);
        }
    };
    const change_page = (pageNumber) => {
        setCurrentPage(pageNumber);
        const url = new URL(window.location);
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url); // updates the URL without rewait_submitting
        load_data(pageNumber);
    };


    const handleNotifyRequester = (id_supplier, request_code, supplier_name) => {
        setwait_submitting(true);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('id_supplier', id_supplier);
        formData.append('sender_name', supplier_name);
        notify_purchase_service_with_quote_upload(formData).then((response) => {
            console.log("Notification sent successfully:", response.data);
            swal("Le service d'achat a été notifié avec succès !", {
                icon: "success",
            });
        }).catch((error) => {
            console.error(error.response);
            setwait_submitting(false);
        });
        setwait_submitting(false);
    }

    function upload_quote(file, id_supplier, request_code, order_id) {
        setwait_submitting(true);
        let formData = new FormData();
        formData.append('request_code', request_code);
        formData.append('id_supplier', id_supplier);
        formData.append('quote_file', file);
        formData.append('order_id', order_id);

        add_quote_to_orderRequest(formData).then((response) => {
            setQuotePath(response.data.quote_path); // optional: store for later use
            console.log("Quote uploaded at path:", response.data.quote_path);
            setwait_submitting(false);
        }).catch((error) => {
            console.error(error.response);
            setwait_submitting(false);
        });
        setwait_submitting(false);

    }

    async function download_quote(e, order_infos) {
        setwait_submitting(true);
        e.stopPropagation();
        let formData = new FormData();
        formData.append('request_code', order_infos.request_code);
        formData.append('order_id', order_infos.order_id);

        await download_orderRequest_quote(formData).then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;

            let file_extension = 'pdf';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }

            fileLink.setAttribute(
                'download',
                `${order_infos.request_code.replaceAll(" ", "_")}_${order_infos.order_id}_devis.${file_extension}`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(err => {
            console.error("Error downloading quote", err);
        });
        setwait_submitting(false);
    }



    return (
        <>
            {

                <div className='applicant_request_view' >
                    {/* <div className='bills_src_header'>
                        <FormControl variant="standard" className="header_form" >
                            <InputLabel id="demo-simple-select-helper-label">Devis</InputLabel>
                            <br />
                        </FormControl>
                    </div> */}
                    <div className='three_forms_header_container'>
                        <div className='page_title'>Devis</div>

                    </div>

                    <div className="bills_table_container">
                        <TableContainer className="bills_table">
                            <Table className='applicant_requests_table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ marginRight: '20px' }}>Code de demande</TableCell>
                                        <TableCell>Devis</TableCell>
                                        <TableCell>Date d'ajout</TableCell>
                                        <TableCell>Retenue</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {requests.length > 0 ? (
                                        requests.map((requestRow, id) => (
                                            <TableRow key={"offcat_" + id}>
                                                <TableCell>{requestRow.request_code}</TableCell>
                                                <TableCell>
                                                    {requestRow.quote ? (
                                                        <Tooltip title="Télécharger le devis" placement="bottom">
                                                            <span
                                                                style={{ marginRight: '8px' }}
                                                                onClick={(e) => download_quote(e, requestRow)}
                                                            >
                                                                <Fab
                                                                    size="small"
                                                                    style={{ backgroundColor: '#efefef', color: 'black' }}
                                                                    className={requestRow.order_state !== null ? "round_button" : "round_button disabled_button"}
                                                                >
                                                                    <DownloadIcon className="my_icon" />
                                                                </Fab>
                                                            </span>
                                                        </Tooltip>
                                                    ) : (
                                                        <span style={{ color: '#aaa' }}>Aucun devis déposé</span>
                                                    )}
                                                </TableCell>

                                                <TableCell>
                                                    {requestRow.quoteStudy_date ? new Date(requestRow.quoteStudy_date).toLocaleDateString() : "Pas encore"}
                                                </TableCell>


                                                <TableCell>
                                                    {
                                                        requestRow.service_accord === null
                                                            ? <Button variant="contained" className="status_waiting">Pas encore</Button>
                                                            : requestRow.service_accord === 1
                                                                ? <Button variant="contained" className="status_success">Oui</Button>
                                                                : <Button variant="contained" className="status_deny">Non</Button>
                                                    }

                                                    <>
                                                        {
                                                            requestRow.order_state === "non retenue"
                                                                ? <span className='view_reason_button' onClick={(e) => { e.stopPropagation(); setOpen_reason_modal(requestRow.service_refuse_reason) }}>Motif</span>
                                                                : <></>
                                                        }
                                                    </>
                                                </TableCell>
                                                <TableCell>
                                                    <Tooltip title="Importer le devis" placement="bottom">
                                                        <>
                                                            <input
                                                                accept='application/*'
                                                                className={classes.input}
                                                                id={'uploadQuote' + requestRow.order_id}
                                                                type='file'
                                                                onChange={(e) => upload_quote(
                                                                    e.target.files[0],
                                                                    supplier.id,
                                                                    requestRow.request_code,
                                                                    requestRow.order_id
                                                                )}
                                                            />
                                                            <label htmlFor={'uploadQuote' + requestRow.order_id}>
                                                                <span className="view_reason_button" style={{ cursor: 'pointer' }}>
                                                                    Importer le devis
                                                                </span>
                                                            </label>
                                                        </>
                                                    </Tooltip>
                                                    {requestRow.quote && (<Tooltip title="Notifier le service d'achat" placement="bottom" style={{ marginLeft: '10px' }}>
                                                        <>
                                                            <label>
                                                                <span className="view_reason_button" style={{ cursor: 'pointer' }} onClick={() => handleNotifyRequester(supplier.id, requestRow.request_code, supplier.fullName)}>
                                                                    Notifier le service d'achat
                                                                </span>
                                                            </label>
                                                        </>
                                                    </Tooltip>)}



                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <div style={{ margin: "10px", fontSize: '.75rem', textAlign: "center", alignContent: "center" }}>
                                            Aucun devis
                                        </div>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    {totalItems > 0 && (
                        <div className="pagination_container">
                            <Pagination
                                activePage={currentPage}
                                itemsCountPerPage={6}
                                totalItemsCount={totalItems}
                                pageRangeDisplayed={4}
                                onChange={change_page}
                            />
                        </div>
                    )}

                </div >
            }
            {
                open_reason_modal !== null
                    ? <View_refuse_reason open_reason_modal={open_reason_modal} setOpen_reason_modal={setOpen_reason_modal} />
                    : <></>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={wait_submitting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </>
    );


}
export default Supplier_quotes;